import {RouteAutoSequenceTypeCd} from '../';
import {EnumHelper} from './enum-helper';

export class RouteAutoSequenceTypeCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in RouteAutoSequenceTypeCd ) {
      this._values.push(RouteAutoSequenceTypeCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): RouteAutoSequenceTypeCd {

    for ( const obj in RouteAutoSequenceTypeCd ) {
      if (RouteAutoSequenceTypeCd[obj] === value){
        return RouteAutoSequenceTypeCd[obj] as RouteAutoSequenceTypeCd;
      }
    }
  }
}

const RouteAutoSequenceTypeCdHelper = new RouteAutoSequenceTypeCdHelperEnumHelperClass();
export default RouteAutoSequenceTypeCdHelper;
